import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useRiskFactorStyle = createUseStyles({
    separator: {
        height: 1,
        width: '100%',
        background: color.border.opaque,
        margin: `${spacing['06']} 0`,
    },
});
